import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: 'input[somenteNumeros]' })
export class SomenteNumerosDirective {

  constructor(private readonly el: ElementRef<HTMLInputElement>) {
  }

  @HostListener('input', ['$event'])
  public onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.replace(/\D/g, '');
    if(initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
